import { UntypedFormGroup, AbstractControl } from '@angular/forms';
import { UserInputOptionType } from '../../../shared-models/user-input-option-type';
import { ISelectOptionGroup } from '../../models/select-option-group';

export class FormUtility {
  static onBeforeSave(formGroup: UntypedFormGroup) {
    this.touchControls(formGroup);

    formGroup.updateValueAndValidity();
  }
  static touchControls(formGroup: UntypedFormGroup): any {
    Object.keys(formGroup.controls)
      .map(e => formGroup.controls[e])
      .forEach((control: UntypedFormGroup) => {
        control.markAsTouched();

        if (control.controls) {
          this.touchControls(control);
        }
      });
  }

  static hasValue(control: AbstractControl): boolean {
    const formGroup = control as UntypedFormGroup;

    if (formGroup && formGroup.controls) {
      for (const key in formGroup.controls) {
        if (formGroup.controls.hasOwnProperty(key)) {
          const child = formGroup.controls[key];

          if (this.hasValue(child)) {
            return true;
          }
        }
      }
    } else {
      return !!control.value;
    }
  }

  static getYesNoOptions(): ISelectOptionGroup[] {
    return [
      {
        name: 'yesNo',
        options: [
          { name: 'Yes', value: true, sortOrder: 1, isDeleted: false },
          { name: 'No', value: false, sortOrder: 2, isDeleted: false },
        ],
        sortOrder: 1,
      },
    ];
  }

  static getInternalExternalOptions(): ISelectOptionGroup[] {
    return [
      {
        name: 'internalExternal',
        options: [
          { name: 'Internal', value: true, sortOrder: 1, isDeleted: false },
          { name: 'External', value: false, sortOrder: 2, isDeleted: false },
        ],
        sortOrder: 1,
      },
    ];
  }

  static getUserInputOptions(): ISelectOptionGroup[] {
    return [
      {
        name: 'userInputOptions',
        options: [
          { name: 'Contains', value: UserInputOptionType.Contains, sortOrder: 1, isDeleted: false },
          {
            name: 'Starts With',
            value: UserInputOptionType.StartsWith,
            sortOrder: 2,
            isDeleted: false,
          },
          {
            name: 'Ends With',
            value: UserInputOptionType.EndsWith,
            sortOrder: 3,
            isDeleted: false,
          },
        ],
        defaultValue: UserInputOptionType.Contains,
        sortOrder: 1,
      },
    ];
  }

  static getPriorityOptions(): ISelectOptionGroup[] {
    return [
      {
        name: 'priority',
        options: [
          { name: 'High', value: true, sortOrder: 1, isDeleted: false },
          { name: 'Normal', value: false, sortOrder: 2, isDeleted: false },
        ],
        sortOrder: 1,
        defaultValue: false,
      },
    ];
  }

  static getIsOptInEmailNotificationOptions(): ISelectOptionGroup[] {
    return [
      {
        name: 'priority',
        options: [
          { name: 'Email', value: 'Email', sortOrder: 1, isDeleted: false },
          { name: 'None', value: 'None', sortOrder: 2, isDeleted: false },
        ],
        sortOrder: 1,
        defaultValue: 'Email',
      },
    ];
  }

  static getActiveInactiveOptions(): ISelectOptionGroup[] {
    return [
      {
        name: 'activeInactive',
        options: [
          { name: 'Active', value: true, sortOrder: 1, isDeleted: false },
          { name: 'Inactive', value: false, sortOrder: 2, isDeleted: false },
        ],
        sortOrder: 1,
        defaultValue: false,
      },
    ];
  }

  static markFormGroupTouched(component: any, formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach((control: UntypedFormGroup) => {
      control.markAsTouched();

      if (control.controls) {
        component.markFormGroupTouched(control);
      }
      //control is of type FormControl in this part of the code
    });
  }
}
